import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

import { splitByExcludeFields } from '../../constants/metainf';
import { prepareDropdown } from '../../utils/common';
import FieldsSelect from '../common/FieldsSelect';

const StyledColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 15px;
`;

const StyledDeleteButton = styled(Button)`
  border: none;
`;

const StyledAddButton = styled(Button)`
  margin-bottom: 15px;
`;

const UsersColumns = ({
  columns,
  setUsersEventColumnValue,
  metainf,
  deleteUsersEventColumn,
  addUsersEventColumn,
}) => (
  <>
    <h3>Columns</h3>
    {columns.map((c) => (
      <StyledColumnContainer key={c.id}>
        <FieldsSelect
          onSelect={(value) => setUsersEventColumnValue(c.id, value)}
          value={c.label || undefined}
          fields={prepareDropdown(metainf, true, splitByExcludeFields)}
          style={{ width: '100%' }}
          allowClear
        />
        <StyledDeleteButton
          onClick={() => deleteUsersEventColumn(c.id)}
          icon={<DeleteOutlined />}
        />
      </StyledColumnContainer>
    ))}
    <StyledAddButton onClick={addUsersEventColumn} icon={<PlusOutlined />}>
      Add column
    </StyledAddButton>
  </>
);

export default UsersColumns;
